import _ from 'lodash';
import React, { Component } from 'react';
import { Input, Calendar } from './';
import moment from 'moment';
import $ from 'jquery';

// Import the CSS
import '../../scss/components/_date-input.scss';

export default class DateInput extends Component {
	constructor (props) {
		super(props);

		this.state = {
			id: Math.random(),
			showCalendar: false,
			value: props.defaultValue,
		};
	}

	handleClick (e) {
		e.preventDefault();
	}

	handleFocus (e) {
		this.showCalendar();
	}

	handleBlur (e) {
		if (!this.state.showCalendar) {
			this.setDate(this.state.value);
		}
	}

	handleChange (e) {
		e.preventDefault();

		let value = e.target.value.replace(/[^0-9\/]/g, '');

		this.setState({ value });
		this.hideCalendar();
	}

	handleSelectDate (date) {
		this.setDate(date.format('YYYY/MM/DD'));
		this.hideCalendar();
	}

	setDate (date) {
		const formattedDate = this.formatDate(date);

		this.setState({ value: formattedDate });

		if (this.props.onSetDate) {
			this.props.onSetDate(formattedDate);
		}
	}

	formatDate (date) {
		if (!date || date === this.props.defaultValue) {
			return date;
		}

		const dateArray = date.split('/', 3);
		let format;

		// Feed the date through moment so we can format it properly
		switch (dateArray.length) {
			case 1:
				format = 'YYYY';
				break;
			case 2:
				format = 'YYYY/MM';
				break;
			case 3:
				format = 'YYYY/MM/DD';
				break;
			default:
				return '';
		}

		const momentDate = moment(dateArray, format);

		if (format === 'YYYY') {
			format += '/01';
		}

		return momentDate.isValid() ? momentDate.format(format) : '';
	}

	showCalendar () {

		let selector = `mousedown.date-input-${this.state.id}`;

		// Show the calendar
		this.setState({ showCalendar: true });

		// Listen for click events outside of the calendar so
		// we can close the calendar when the user clicks outside.
		$(document).off(selector).on(selector, e => {

			// Get the closest date input ancestor
			let closestDateInput = $(e.target).closest('.date-input').get(0);

			// Check if the closest date input doesn't match this component.
			// If it doesn't, then hide the calendar, since we've clicked
			// outside of the component.
			if (closestDateInput != this._dateInput) {
				this.hideCalendar();
			}
		});

	}

	hideCalendar () {

		// Hide the calendar
		this.setState({ showCalendar: false });

		// Remove the document event listener, since we no longer
		// need to listen for clicks outside of the calendar.
		$(document).off(`mousedown.date-input-${this.state.id}`);

	}

	render () {

		let classes = [ 'date-input' ];
		let calendar;
		const inputProps = _.omit(this.props, [ 'onSetDate', 'defaultValue' ]);

		// Add additional classes based on the props
		if (this.state.showCalendar) {

			classes.push('date-input-visible');

			calendar = (
				<Calendar
					ref={ calendar => this._calendar = calendar }
					selectedDate={ this.state.value }
					onSelectDate={ date => this.handleSelectDate(date) } />
			);

		}

		return (
			<div ref={ container => this._dateInput = container } className={ classes.join(' ') } onClick={ e => this.handleClick(e) }>
				<label>
					<Input
						ref={ input => this._input = input }
						type="text"
						value={ this.state.value }
						onChange={ e => this.handleChange(e) }
						onFocus={ e => this.handleFocus(e) }
						onBlur={ e => this.handleBlur(e) }
						{ ...inputProps } />
				</label>
				{ calendar }
			</div>
		);
	}
}

DateInput.propTypes = {
	onSetDate: React.PropTypes.func,
	style: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/assets/js/components/DateInput.js